var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.session && _vm.features.canNavigateInSession())?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-8 mx-auto mt-3 mb-5"},[_c('div',{staticClass:"steps"},[(_vm.features.canOpenConfiguration())?_c('button',{staticClass:"steps-btn",class:{
                    'highlighted': _vm.configurationHighlighted,
                    'enabled': _vm.configurationEnabled,
                    'current': _vm.current == 'configuration'
                },on:{"click":_vm.openConfiguration}},[_c('span',[_vm._v(_vm._s(_vm.$t('sessions.configuration')))])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"steps-btn",class:{
                    'highlighted': _vm.observationHighlighted,
                    'enabled': _vm.observationEnabled,
                    'current': _vm.current == 'observation',
                    'notfirst': _vm.features.canOpenConfiguration()
                },on:{"click":_vm.openObservation}},[_c('span',[_vm._v(_vm._s(_vm.$t('sessions.observation')))])]),_vm._v(" "),_c('button',{staticClass:"steps-btn notfirst",class:{
                    'highlighted': _vm.evaluationHighlighted,
                    'enabled': _vm.evaluationEnabled,
                    'current': _vm.current == 'evaluation'
                },on:{"click":_vm.openEvaluation}},[_c('span',[_vm._v(_vm._s(_vm.$t('sessions.evaluation')))])]),_vm._v(" "),_c('button',{staticClass:"steps-btn notfirst",class:{
                    'highlighted': _vm.summaryHighlighted,
                    'enabled': _vm.summaryEnabled,
                    'current': _vm.current == 'summary'
                },on:{"click":_vm.openSummary}},[_c('span',[_vm._v(_vm._s(_vm.$t('sessions.summary')))])])])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }